import { ValidationSchemaType } from 'hooks/useForm';
import { NestedProduct } from '../types/dtos';

export const NESTED_PRODUCT_INITIAL_FIELDS: NestedProduct = {
    id: '',
    name: '',
    websiteId: '',
    description: '',
    nestedProductCategoryId: '',
};

export const NESTED_PRODUCT_FIELDS_SCHEMA: ValidationSchemaType<NestedProduct> = {
    name: {
        required: true,
        maxLength: 100,
    },
    nestedProductCategoryId: {
        required: true,
    },
};
